import { render, staticRenderFns } from "./IconOneDrive.vue?vue&type=template&id=6e13e80a&"
import script from "./IconOneDrive.vue?vue&type=script&lang=js&"
export * from "./IconOneDrive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e13e80a')) {
      api.createRecord('6e13e80a', component.options)
    } else {
      api.reload('6e13e80a', component.options)
    }
    module.hot.accept("./IconOneDrive.vue?vue&type=template&id=6e13e80a&", function () {
      api.rerender('6e13e80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconOneDrive.vue"
export default component.exports